module.exports = __webpack_public_path__ + "static/media/sveuciliste-u-splitu.7ba5e9cd.svg";